import withI18n from './withI18n';

export default withI18n;
